module.exports = __webpack_public_path__ + "img/cat-08.684f734a.png";